import React from 'react';
import { RhNumberField } from '../../../../../../../dum';
import { TOTAL_WITH_TAX } from '../../order-sale-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function TotalInput() {
    return (
        <RhNumberField
            name={TOTAL_WITH_TAX}
            label={shortLabel(FIELD_LABELS.total_with_tax)}
            disabled
        />
    );
}
